import { Metric } from '../types';

export const emptyMetric = (metricName: string) => ({
  metricName,
  value: 0,
  unit: 'Count',
  organizationId: 0,
});

export const filterMetricOrMetrics = (
  metricOrMetrics: Metric | Metric[],
  filterFn: (metric: Metric) => boolean,
) => {
  if (Array.isArray(metricOrMetrics)) {
    return metricOrMetrics.find(filterFn) || emptyMetric(metricOrMetrics[0].metricName);
  } else {
    return filterFn(metricOrMetrics) ? metricOrMetrics : emptyMetric(metricOrMetrics.metricName);
  }
};

export const pickMetric =
  (metricsByMetricName: Record<string, Metric | Metric[]>) =>
  (metricName: string, filterFn?: (metric: Metric) => boolean) => {
    const metricOrMetrics = metricsByMetricName[metricName];

    if (!metricOrMetrics) return emptyMetric(metricName);

    if (typeof filterFn === 'function') return filterMetricOrMetrics(metricOrMetrics, filterFn);

    return Array.isArray(metricOrMetrics) ? metricOrMetrics[0] : metricOrMetrics;
  };
